import { IBasicEvent, IBasicFile } from '@sdk/contracts';

export function hasViewedLiveRecord(
  event: IBasicEvent,
  record: IBasicFile,
  userId?: string
): boolean {
  const insights = event.conferenceData?.insights;
  const recordedParticipants = insights?.recordedParticipants;
  if (!recordedParticipants || !Array.isArray(recordedParticipants)) return false;

  return recordedParticipants.some(participant => {
    if (!(typeof participant === 'object' && participant !== null)) return false;
    const matchesRecord =
      typeof participant.liveRecordId === 'string' && participant.liveRecordId === record._id;
    if (!matchesRecord) return false;
    if (!userId) return true;
    return participant?.user?._id === userId;
  });
}
